"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCategoryQuickLinks = void 0;

var getCategoryQuickLinks = function getCategoryQuickLinks(modules, user) {
  var links = [];

  if (modules.includes('CommunityOverviewOpenForAllUsers')) {
    links.push({
      url: '/community',
      phrase: {
        m: 'Forum',
        p: 'nav.title.community.overview'
      }
    });
  } else {
    links.push({
      url: '/',
      phrase: {
        m: 'Common',
        p: 'nav.title.forum.overview'
      }
    });
  }

  links.push({
    url: '/activity/recent',
    phrase: {
      m: 'Common',
      p: 'nav.title.forum.recent.activity'
    }
  });

  if (user.id) {
    links.push({
      url: '/activity/sincelastvisit',
      phrase: {
        m: 'Common',
        p: 'nav.title.forum.activity.last.visit'
      }
    });
  }

  links.push({
    url: '/activity/unanswered',
    phrase: {
      m: 'Common',
      p: 'nav.title.forum.unanswered.questions'
    }
  });
  return links;
};

exports.getCategoryQuickLinks = getCategoryQuickLinks;